import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableBaseComponent } from '@components/datatable-base.component';
import { trigger, state, style } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { UiService } from '@services/ui.service';
import { ContainersService } from '@services/containers.service';
import { Container } from '@classes/container';
import { MatPaginator } from '@angular/material/paginator';
import { UsersService } from '@services/users.service';

@Component({
  selector: 'app-containers',
  templateUrl: './containers.component.html',
  styleUrls: ['./containers.component.scss'],
  animations: [
    trigger('detailExpand', [
      state(
        'collapsed',
        style({ height: '0px', minHeight: '0', display: 'none' }),
      ),
      state('expanded', style({ height: '*' })),
    ]),
  ],
})
export class ContainersComponent
  extends DatatableBaseComponent
  implements OnInit
{
  containers: Container[];

  displayedColumns = [
    'identifier',
    'description',
    'productType',
    'tag',
    'client',
    'actions',
  ];
  dataSource: MatTableDataSource<Container>;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    protected uiSrv: UiService,
    private route: ActivatedRoute,
    private containersSrv: ContainersService,
    private _usersService: UsersService,
  ) {
    super(uiSrv);
  }

  ngOnInit() {
    super.ngOnInit();
    this.getRouteData();
    this.initSubscriptions();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.containers);
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'client':
          return item.client.name;
        case 'productType':
          return item.productType.name;
        default:
          return item[property];
      }
    };
    this.dataSource.filterPredicate = (data, filter: string) => {
      const accumulator = (currentTerm, key) => {
        switch (key) {
          case 'client':
            return currentTerm + data.client.name;
          case 'productType':
            return currentTerm + data.productType.name;
          default:
            return currentTerm + data[key];
        }
      };
      const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
      // Transform the filter by converting it to lowercase and removing whitespace.
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };
    this.dataSource.sort = this.sort;
  }

  private getRouteData(): void {
    this.route.data.subscribe((data: { containers: Container[] }) => {
      this.containers = data.containers;
      this.initTable();
    });
  }

  private initSubscriptions(): void {
    this.addSubscription(
      this.containersSrv.containersListChanged.subscribe((containers) => {
        this.dataSource.data = containers || [];
        this.dataSource.sort = this.sort;
        this.onEditFinished();
      }),
    );
    this.addSubscription(
      this._usersService.globalSelectedClientSubject.subscribe(() => {
        this.containersSrv.getList().subscribe();
      }),
    );
  }

  delete(idContainer: string) {
    const confirmation = confirm(
      'Êtes-vous certain de vouloir supprimer ce conteneur ?',
    );

    if (confirmation) {
      this.containersSrv.delete(idContainer).subscribe(() => {
        this.uiSrv.showSnackbar('repository.containers.deleted', true);
      });
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
